import { render, staticRenderFns } from "./OriginGroups.vue?vue&type=template&id=29d8b08b&"
import script from "./OriginGroups.vue?vue&type=script&lang=js&"
export * from "./OriginGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports